export const DELIVERY_TIMES = [
  '24hs',
  '48hs',
  '72hs',
  '5 Dias Habiles',
  '10 Dias Habiles',
  '15 Dias Habiles'
] as const;

export type DeliveryTime = typeof DELIVERY_TIMES[number];

export const CATEGORY_LABELS: Record<string, string> = {
  'lentes': 'Lentes',
  'armazones': 'Armazones',
  'contacto': 'Lentes de Contacto',
  'accesorios': 'Accesorios'
};